import React, { useState, useEffect } from "react";
import Loader from "react-loader-spinner";

const Form = ({formData, setFormData, handleDataSubmission, loading, submitted}) => {
  const [formValues, setFormValues] = useState({
    applicationInputs: {},
    contactInputs: {},
  });
  const [currentPage, setCurrentPage] = useState(1);

  const nextPage = () => {
    setCurrentPage((prev) => {
      return prev + 1;
    });
  };

  const handleBack = () => {
    setCurrentPage((prev) => {
      return prev - 1;
    });
  };

  const handleSelectOption = (e) => {
    const targetElement = e.target;

    setFormData({
      ...formData,
      [targetElement.getAttribute("data-option-key")]:
        targetElement.textContent,
    });

    nextPage();
  };

  const handleApplicationInputChange = (e) => {
    const targetElement = e.target;

    setFormData({
      ...formData,
      applicationInputs: {
        ...formData.applicationInputs,
        [targetElement.name]: targetElement.value,
      },
    });
  };

  const handleApplicationValues = (e) => {
    e.preventDefault();

    nextPage();
  };

  const handleContactChange = (e) => {
    const targetElement = e.target;

    setFormData({
      ...formData,
      contactInputs: {
        ...formData.contactInputs,
        [targetElement.name]: targetElement.value,
      },
    });
  };

  // useEffect(() => {
  //   console.log(formData);
  // }, [formData]);

  useEffect(() => {
    setFormData({
      ...formData,
      applicationInputs: {},
    });
  }, [formData.application]);

  // useEffect(() => {

  //   if(currentPage === 8) {
  //     setViewSubmitBtn(true)
  //   } else {
  //     setViewSubmitBtn(false)
  //   }

  // }, [currentPage])

  return (
    <>
      <div className="container">
        <div className="clw-logo"></div>

        {loading ? <div className="loadingContainer">
        <Loader
      type="Oval"
      color={'black'}
      height={50}
      width={50}
      timeout={40000}
    />
        </div> : currentPage === 1 ? (
          <div className="page">
            <section>
              <h2 className="heading">
                What grow lights do you have currently installed?
              </h2>
              <div>
                <div className="options-row">
                  <div
                    className="option-item"
                    data-option-key="installed-lights"
                    onClick={handleSelectOption}
                  >
                    HPS
                  </div>
                  <div
                    className="option-item"
                    data-option-key="installed-lights"
                    onClick={handleSelectOption}
                  >
                    LED
                  </div>
                </div>
                <div className="options-row">
                  <div
                    className="option-item"
                    data-option-key="installed-lights"
                    onClick={handleSelectOption}
                  >
                    None
                  </div>
                </div>
              </div>
            </section>
          </div>
        ) : currentPage === 2 ? (
          <div className="page">
            <section>
              <h2 className="heading">What is your total canopy size?</h2>
              <div className="options-row">
                <div
                  className="option-item"
                  data-option-key="canopy-size"
                  onClick={handleSelectOption}
                >
                  Under 20k sq. ft.
                </div>
                <div
                  className="option-item"
                  data-option-key="canopy-size"
                  onClick={handleSelectOption}
                >
                  Above 20k sq. ft.
                </div>
              </div>
            </section>
          </div>
        ) : currentPage === 3 ? (
          <div className="page">
            <section>
              <h2 className="heading">What is your crop type?</h2>
              <div>
                <div className="options-row">
                  <div
                    className="option-item"
                    data-option-key="crop-type"
                    onClick={handleSelectOption}
                  >
                    Cannabis
                  </div>
                  <div
                    className="option-item"
                    data-option-key="crop-type"
                    onClick={handleSelectOption}
                  >
                    Produce
                  </div>
                </div>
                <div className="options-row">
                  <div
                    className="option-item"
                    data-option-key="crop-type"
                    onClick={handleSelectOption}
                  >
                    Ornamental
                  </div>
                  <div
                    className="option-item"
                    data-option-key="crop-type"
                    onClick={handleSelectOption}
                  >
                    Research
                  </div>
                </div>
                <div className="options-row">
                  <div
                    className="option-item"
                    data-option-key="crop-type"
                    onClick={handleSelectOption}
                  >
                    Other
                  </div>
                </div>
              </div>
            </section>
          </div>
        ) : currentPage === 4 ? (
          <div className="page">
            <section>
              <h2 className="heading">What type of layout do you have?</h2>
              <div className="options-row">
                <div
                  className="option-item"
                  data-option-key="layout-type"
                  onClick={handleSelectOption}
                >
                  Static Rows
                </div>
                <div
                  className="option-item"
                  data-option-key="layout-type"
                  onClick={handleSelectOption}
                >
                  Rolling Benches
                </div>
              </div>
            </section>
          </div>
        ) : currentPage === 5 ? (
          <div className="page">
            <section>
              <h2 className="heading">Please choose your application:</h2>

              <div>
                <div className="options-row">
                  <div
                    className="option-item"
                    data-option-key="application"
                    onClick={handleSelectOption}
                  >
                    Indoor
                  </div>

                  <div
                    className="option-item"
                    data-option-key="application"
                    onClick={handleSelectOption}
                  >
                    Greenhouse
                  </div>
                </div>
                <div className="options-row">
                  <div
                    className="option-item"
                    data-option-key="application"
                    onClick={handleSelectOption}
                  >
                    Multi Level
                  </div>
                </div>
              </div>
            </section>
          </div>
        ) : currentPage === 6 && formData.application === "Multi Level" ? (
          <div className="page">
            <section>
              <h2 className="heading-left">Multi Level:</h2>
              <div className="form-section">
                <form onSubmit={handleApplicationValues}>
                  <div className="form-inputs">
                    <div className="form-input-row-group">
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="#oflevelsflower">
                          # of Levels Flower:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="oflevelsflower"
                          onChange={handleApplicationInputChange}
                        />
                      </div>
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="#oflevelsveg">
                          # of Levels Veg:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="oflevelsveg"
                          onChange={handleApplicationInputChange}
                        />
                      </div>
                    </div>

                    <div className="form-input-row-group">
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="sqmother">
                          sq. ft. Mother:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="sqmother"
                          onChange={handleApplicationInputChange}
                        />
                      </div>
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="sqpropagation">
                          sq. ft. Propagation:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="sqpropagation"
                          onChange={handleApplicationInputChange}
                        />
                      </div>
                    </div>

                    <div className="form-input-row-group">
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="sqveg">
                          sq. ft. Veg:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="sqveg"
                          onChange={handleApplicationInputChange}
                        />
                      </div>
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="sqflower">
                          sq. ft. Flower:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="sqflower"
                          onChange={handleApplicationInputChange}
                        />
                      </div>
                    </div>
                  </div>

                  <button type="submit" className="btn nextBtn">
                    Next
                  </button>
                </form>
              </div>
            </section>
          </div>
        ) : currentPage === 6 && formData.application === "Indoor" ? (
          <div className="page">
            <section>
              <h2 className="heading-left">Indoor:</h2>
              <div className="form-section">
                <form onSubmit={handleApplicationValues}>
                  <div className="form-inputs">
                    <div className="form-input-row-group">
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="sqmother">
                          sq. ft. Mother:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="sqmother"
                          onChange={handleApplicationInputChange}
                        />
                      </div>
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="sqpropagation">
                          sq. ft. Propagation:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="sqpropagation"
                          onChange={handleApplicationInputChange}
                        />
                      </div>
                    </div>

                    <div className="form-input-row-group">
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="sqveg">
                          sq. ft. Veg:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="sqveg"
                          onChange={handleApplicationInputChange}
                        />
                      </div>
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="sqflower">
                          sq. ft. Flower:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="sqflower"
                          onChange={handleApplicationInputChange}
                        />
                      </div>
                    </div>
                  </div>

                  <button type="submit" className="btn nextBtn">
                    Next
                  </button>
                </form>
              </div>
            </section>
          </div>
        ) : currentPage === 6 && formData.application === "Greenhouse" ? (
          <div className="page">
            <section>
              <h2 className="heading-left">Greenhouse:</h2>
              <div className="form-section">
                <form onSubmit={handleApplicationValues}>
                  <div className="form-inputs">
                    <div className="form-input-row-group">
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="sqmother">
                          sq. ft. Mother:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="sqmother"
                          onChange={handleApplicationInputChange}
                        />
                      </div>
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="sqpropagation">
                          sq. ft. Propagation:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="sqpropagation"
                          onChange={handleApplicationInputChange}
                        />
                      </div>
                    </div>

                    <div className="form-input-row-group">
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="sqveg">
                          sq. ft. Veg:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="sqveg"
                          onChange={handleApplicationInputChange}
                        />
                      </div>
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="sqflower">
                          sq. ft. Flower:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="sqflower"
                          onChange={handleApplicationInputChange}
                        />
                      </div>
                    </div>
                  </div>

                  <button type="submit" className="btn nextBtn">
                    Next
                  </button>
                </form>
              </div>
            </section>
          </div>
        ) : currentPage === 7 ? (
          <div className="page">
            <section>
              <h2 className="heading">
                How soon are you ready to install new lights?
              </h2>
              <div>
                <div className="options-row">
                  <div
                    className="option-item"
                    data-option-key="ready-to-install"
                    onClick={handleSelectOption}
                  >
                    Immediately
                  </div>
                  <div
                    className="option-item"
                    data-option-key="ready-to-install"
                    onClick={handleSelectOption}
                  >
                    Very Soon
                  </div>
                </div>
                <div className="options-row">
                  <div
                    className="option-item"
                    data-option-key="ready-to-install"
                    onClick={handleSelectOption}
                  >
                    Next Few Months
                  </div>
                  <div
                    className="option-item"
                    data-option-key="ready-to-install"
                    onClick={handleSelectOption}
                  >
                    Not Sure
                  </div>
                </div>
              </div>
            </section>
          </div>
        ) : currentPage === 8 ? (
          <div className="page">
            <section>
              <h2 className="heading">Please provide your contact details:</h2>
              <div className="form-section">
                <form onSubmit={handleDataSubmission}>
                  <div className="form-inputs">
                    <div className="form-input-row-group">
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="name">
                          Name:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="name"
                          onChange={handleContactChange}
                        />
                      </div>
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="company">
                          Company:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="company"
                          onChange={handleContactChange}
                        />
                      </div>
                    </div>

                    <div className="form-input-row-group">
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="phone">
                          Phone:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="phone"
                          onChange={handleContactChange}
                        />
                      </div>
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="email">
                          Email:
                        </label>
                        <input
                          className="inputs"
                          type="email"
                          required
                          name="email"
                          onChange={handleContactChange}
                        />
                      </div>
                    </div>

                    <div className="form-input-row-group">
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="city">
                          City:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="city"
                          onChange={handleContactChange}
                        />
                      </div>
                      <div className="form-input-row-item">
                        <label className="labels" htmlFor="state">
                          State:
                        </label>
                        <input
                          className="inputs"
                          type="text"
                          required
                          name="state"
                          onChange={handleContactChange}
                        />
                      </div>
                    </div>
                  </div>

                  <button type="submit" className="btn nextBtn">
                    Submit
                  </button>
                </form>
              </div>
            </section>
          </div>
        ) : (
          <div>Else!</div>
        )}

        {currentPage > 1 && currentPage < 9 && !loading ? (
          <button className="btn backBtn" onClick={handleBack}>
            Back
          </button>
        ) : undefined}
      </div>
    </>
  );
};

export default Form;
